import { render, staticRenderFns } from "./like-button.vue?vue&type=template&id=569e7111&scoped=true&"
import script from "./like-button.vue?vue&type=script&lang=js&"
export * from "./like-button.vue?vue&type=script&lang=js&"
import style0 from "./like-button.vue?vue&type=style&index=0&id=569e7111&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569e7111",
  null
  
)

export default component.exports